import { Box, styled } from '@mui/material';

const RowWrapper = styled(Box)`
  display: flex;
  gap: 6px;
  padding: 0 4px;
`;

export default RowWrapper;
